export default {
  isMeetingInProgress: false,
  isMeetingSpectator: false,
  meetingData: null,
};
